export default "__VITE_ASSET__BXbv9MrA__"